angular.module('qkr').controller('feedbackListController', ($scope, feedbackService, utils) => {
	$scope.feedbacks = [];
	
	feedbackService.load().then((promise) => {
  		    $scope.feedbacks = promise;
        },
        (promise) => {

        }
    );
    
    $scope.feedbackDetail = function(index) {
    	const params = [$scope.feedbacks[index].description, $scope.feedbacks[index].pagName, $scope.feedbacks[index].merchant.name];
    	utils.modalInstanceFeedback(params);
    };
});



// WEBPACK FOOTER //
// ./src/controllers/feedback.list.controller.js